// src/panel.js
import { PANEL_STYLES } from './styles.css.js';

let stylesInjected = false;
function ensureStyles() {
  if (stylesInjected) return;
  const s = document.createElement('style');
  s.setAttribute('data-attraxion-booking', 'styles');
  s.textContent = PANEL_STYLES;
  document.head.appendChild(s);
  stylesInjected = true;
}

export function createPanel({ onOpen, onClose } = {}) {
  ensureStyles();
  const backdrop = document.createElement('div');
  backdrop.className = 'attraxion-backdrop';
  const panel = document.createElement('div');
  panel.className = 'attraxion-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('aria-label', 'Booking');
  document.body.appendChild(backdrop);
  document.body.appendChild(panel);

  let locked = false;

  function open() {
    backdrop.dataset.open = 'true';
    panel.dataset.open = 'true';
    onOpen?.();
  }
  function close() {
    if (locked) return;
    backdrop.dataset.open = 'false';
    panel.dataset.open = 'false';
    onClose?.();
  }
  function setLocked(v) { locked = !!v; }

  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.dataset.open === 'true') close();
  });

  return { open, close, setLocked, panelEl: panel };
}
